$(document).ready(function(){
   $(".upsell_product_in_cart .upsell-area").hide(); 
  if($("body").hasClass("template-cart")){
    var upsell_id = $("#CartDrawer").attr("upsell");
    if($(".cart__item[product-id="+upsell_id+"]").length == 1){
      $(".upsell-area").css({
        "display" : "none !important"
      });

    var upsell_block = $(".cart__page .upsell-area").html();
        localStorage.setItem("upsell-block", upsell_block);
      if(upsell_block != '' && localStorage.getItem('upsell-block') == undefined || localStorage.getItem('upsell-block') == null){
        localStorage.setItem("upsell-block", upsell_block);
      }
      
      $(".cart__page .upsell-area").empty();
    } else {$(".upsell-area").show();}
  }
});
$(document).on("change", ".upsell-area .variants select", function(){
  if ($(this).find("option:selected").attr("image") != '') {
    $(".upsell-area .media img").attr('src', $(this).find("option:selected").attr("image"));
  }
  $(".upsell-area .product-details .price").html($(this).find("option:selected").attr("price"));
});
$(document).on("click", ".upsell-add-to-cart", function(){
  var product_id = $(this).siblings(".variants").find(".upsell-product-id").val();
  var parentUpsell = $(this).closest(".upsell-area");
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: product_id
    },
    dataType: 'json', 
    success: function (data) {

      var product_price = parseInt($(parentUpsell).find('.upsell-area .product-details p.price').attr("product-price"));
      var variant_name = $(parentUpsell).find('.product-details .upsell-product-id option:selected').text();
      var new_item =  '<div class="cart__item" data-key='+ product_id +' product-id='+ product_id +'>' +
                        '<div class="cart__image">' +
                          '<img src="' + $('.upsell-area .media img').attr('src') + '">' +
                        '</div>' +
                        '<div class="cart__item-details">' +
                          '<div class="cart__item-title">' +
                            '<span class="cart__item-name">' +
                              $(parentUpsell).find('.title').text() +
                            '</span>' +
                            '<div class="cart__item--variants"><div><span>Länge:</span> '+ variant_name +'</div></div>' +
                            '<div class="cart__item-price-col" style="display:flex; column-gap: 6px;">' +
                              '<span class="cart__price" product-price="'+ product_price +'">' + $('.upsell-area .product-details p.price').html() + '</span>' +
                            '</div>' +
                          '</div>' +
                          '<button type="button" class="btn remove-upsell">Entfernen</button>' +
                        '</div>' +
                      '</div>';
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json', 
        success: function (cart) {
          console.log(cart);
          if($("body").hasClass("template-cart")){
            $(".cart__page [data-products]").append(new_item);
            var current_cart_total = parseInt($('[data-subtotal]').attr('price-subtotal'));
            $('[data-subtotal]').html(theme.Currency.formatMoney(cart.items_subtotal_price, theme.settings.moneyFormat));
            $('[data-subtotal]').attr('price-subtotal', cart.items_subtotal_price);
          } else {
            $(".drawer__inner .cart__items").append(new_item);
            var current_cart_total = parseInt($('[data-subtotal-ad]').attr('price-subtotal'));
            $('[data-subtotal-ad]').html(theme.Currency.formatMoney(cart.items_subtotal_price, theme.settings.moneyFormat));
            $('[data-total-ad]').html(theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat));
            $('[data-subtotal-ad]').attr('price-subtotal', cart.items_subtotal_price);
          }
          $(".upsell-area").hide();
          

          
          var upsell_block = $(parentUpsell).html();
            localStorage.setItem("upsell-block", upsell_block);
          if(upsell_block != '' && localStorage.getItem('upsell-block') == undefined || localStorage.getItem('upsell-block') == null || localStorage.getItem('upsell-block') == ''){
            localStorage.setItem("upsell-block", upsell_block);
          }
          $(".upsell-area").empty();
        }
      });
    } 
 });
});
$(document).on("click", ".btn.remove-upsell", function(){  console.log("remove");
  var product_id = $(this).parents(".cart__item").attr("data-key");
  if(product_id == undefined){product_id = $(this).parents(".cart__item").attr("product-id")}
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      quantity: 0,
      id: product_id
    },
    dataType: 'json', 
    success: function (data) {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json', 
        success: function (cart) {
          var product_price = parseInt($('.remove-upsell').parents('.cart__item').find('.cart__price').attr("product-price"));
          if($("body").hasClass("template-cart")){
            var current_cart_total = parseInt($('[data-subtotal]').attr('price-subtotal'));
            $('[data-subtotal]').attr('price-subtotal', cart.items_subtotal_price)
            $('[data-subtotal]').html(theme.Currency.formatMoney(cart.items_subtotal_price, theme.settings.moneyFormat));
    
            $(".cart__page .cart__item[data-key='"+product_id+"']").remove();
            $(".cart__page .upsell-area").show();
             var upsell_block = localStorage.getItem("upsell-block");
              $(".cart__page .upsell-area").html(upsell_block);
  
          } else {
            var current_cart_total = parseInt($('[data-subtotal-ad]').attr('price-subtotal'));
            $('[data-subtotal-ad]').html(theme.Currency.formatMoney(cart.items_subtotal_price, theme.settings.moneyFormat));
            $('[data-total-ad]').html(theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat));
            $('[data-subtotal-ad]').attr('price-subtotal', cart.items_subtotal_price);
            
            $(".cart__item[data-key='"+product_id+"']").remove();
            $(".upsell-area").show();
              var upsell_block = localStorage.getItem("upsell-block");
             $(".upsell-area").html(upsell_block);
          }
        }
      });
    } 
 });
});